import * as Bixby from './../../core';
import { AppState } from './..';
import {
  USER_EMAIL_CONFIRMATION_INPROGESS,
  USER_EMAIL_CONFIRMATION_SUCCESS,
  USER_EMAIL_CONFIRMATION_FAILURE,
  VERIFY_USER_EMAIL_CONFIRMATION_INPROGESS,
  VERIFY_USER_EMAIL_CONFIRMATION_SUCCESS,
  VERIFY_USER_EMAIL_CONFIRMATION_FAILURE,
} from './types';
import { FORGOT_PASSWORD_SENT_MESSAGE } from '$/core/constants';
import { ThunkAction } from 'redux-thunk';
import { UserClientService } from '$/services';

export const verifyUserEmailConfirmationRequestInProgress = () => {
  return {
    type: VERIFY_USER_EMAIL_CONFIRMATION_INPROGESS,
  };
};

export const verifyUserEmailConfirmationRequestSuccess = (userEmailConfirmationVerified: boolean) => {
  return {
    type: VERIFY_USER_EMAIL_CONFIRMATION_SUCCESS,
    payload: userEmailConfirmationVerified,
  };
};

export const verifyUserEmailConfirmationRequestFailure = (error: Bixby.Models.BixbyError) => {
  return {
    type: VERIFY_USER_EMAIL_CONFIRMATION_FAILURE,
    payload: error,
    error: true,
  };
};

export const userEmailConfirmationRequestInProgress = () => {
  return {
    type: USER_EMAIL_CONFIRMATION_INPROGESS,
  };
};

export const userEmailConfirmationRequestFailure = (error: Bixby.Models.BixbyError) => {
  return {
    type: USER_EMAIL_CONFIRMATION_FAILURE,
    payload: error,
  };
};

export const userEmailConfirmationRequestSuccess = (successMessage: string) => {
  return {
    type: USER_EMAIL_CONFIRMATION_SUCCESS,
    payload: successMessage,
  };
};

// thunk actions
const handleUserEmailConfirmationError =
  (error: Bixby.Models.BixbyError): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(userEmailConfirmationRequestFailure(error));
  };

const handleUserEmailConfirmationSuccess =
  (successMessage: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(userEmailConfirmationRequestSuccess(successMessage));
  };

export const userEmailConfirmationRequest = (
  userEmailConfirmationRequest: Bixby.Models.UserEmailConfirmationRequest
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(userEmailConfirmationRequestInProgress());
    try {
      await UserClientService.userEmailConfirmation(userEmailConfirmationRequest);
      dispatch(handleUserEmailConfirmationSuccess(FORGOT_PASSWORD_SENT_MESSAGE));
    } catch (error: any) {
      dispatch(handleUserEmailConfirmationError(error));
    }
  };
};

export const verifyUserEmailConfirmationTokenRequest = (
  verifyUserEmailConfirmationRequest: Bixby.Models.VerifyPasswordResetTokenRequest
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(verifyUserEmailConfirmationRequestInProgress());
    try {
      const userEmailConfirmationVerified = await UserClientService.verifyUserEmailConfirmationToken(
        verifyUserEmailConfirmationRequest
      );
      dispatch(verifyUserEmailConfirmationRequestSuccess(userEmailConfirmationVerified));
    } catch (error: any) {
      dispatch(verifyUserEmailConfirmationRequestFailure(error));
    }
  };
};
